module.exports = __webpack_public_path__ + "static/img/mpm_4.e7f18fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpm_4.jpg
// module id = WwsN
// module chunks = 1